import axiosNew from '../../helpers/axios'

// GET STAND UPS DATA
export const getStandUps = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const getFeed = await axiosNew({
                url: `feed/list?limit=${payload.limit}&skip=${payload.skip}${
                    payload?.start ? `&start=${payload?.start}` : ''
                }${payload?.end ? `&end=${payload?.end}` : ''}${
                    payload?.projectId ? `&projectId=${payload?.projectId}` : ''
                }${
                    payload?.titleType ? `&titleType=${payload?.titleType}` : ''
                }${payload?.userId ? `&userId=${payload?.userId}` : ''}
                `,
                method: 'get',
            })
            resolve({ data: getFeed?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// CREATE STAND UP
export const createStandUp = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            let data = payload ?? {}

            const createFeed = await axiosNew({
                url: 'feed/create',
                data,
            })
            resolve({ data: createFeed?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// CREATE STAND UP
export const removeStandUp = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const deleteFeed = await axiosNew({
                url: 'feed/delete/' + payload,
                method: 'delete',
            })
            resolve({ data: deleteFeed?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}
